import useBreadcrumbs from '@admin/hooks/useAdminBreadcrumbs';
import PageHeader from '@shared/components/core/headers/PageHeader';
import ProjectsCreatePageContent from '@shared/components/organization/projects/ProjectsCreatePageContent';
import { useTranslation } from 'react-i18next';

export default function ProjectsNewPage() {
    const { t } = useTranslation();
    const { items } = useBreadcrumbs();

    return (
        <>
            <PageHeader
                title={t('common:organization.projects.create.titleLong')}
                description={t('common:organization.projects.description')}
                items={items}
            />
            <ProjectsCreatePageContent />
        </>
    );
}
